import React, { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../auth/hooks/useAuth";
import { AssignmentsContainer } from "./styled_components/containers";
import Assignment from "./components/assignment";
import Practice from "../games/components/Show/Practice";
import Learn from "../games/components/Show/Learn";
import NumInt from "../games/applications/NumeracyIntervention/Rating"
import MTC from "../games/applications/MTC/Practice"
import Assessment from "../games/applications/MathsAssessments/Basic"
import { Scale } from 'react-scaling';
import { Router, navigate } from "@reach/router";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import PlayButton from "./styled_components/play_button";
import game_data from "../games/game_data"; 

import styled from "styled-components";

function Assignments(props) {
    const { state } = useAuth();
    const { access_token } = state;
    const [assignments, updateAssignments] = useState(null);
    const [doingAssignment, updateDoingAssignment] = useState(null);
    const [answer, setAnswer] = useState("");
    const [displayValue, setDisplayValue] = useState("");
    const [showPin, setShowPin] = useState("");
    const [currentTask, setCurrentTask] = useState(null);
    const [pin, setPin] = useState('');

    // Filter states initialized to defaults
    const [selectedMonth, setSelectedMonth] = useState("All");
    const [selectedSubject, setSelectedSubject] = useState("All");

    const monthsList = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Gather unique subject descriptions from game_data
    const subjectsList = Array.from(
        new Set(game_data.map(game => game.description))
    ).filter(Boolean).sort();

    function EnterPin(task){
        console.log(task);
        setCurrentTask(task);
        setShowPin(true);
    }

    function CheckPin(){
        if (currentTask != null){
            if (pin == currentTask.pin){
                console.log("correct pin");
                DoAssignment();
                setShowPin(false);
            }else{
                console.log("wrong pin");
                window.alert("Wrong pincode");
            }
        }else{
            console.log("no task selected");
            window.alert("No task selected");
            setShowPin(false);
        }
    }

    const PinPopup = () => {
        return (
        <Popup contentStyle={{ width: "550px", height: "250px" }} open={showPin} onClose={() => setShowPin(false)} position="center">
            <div style={{position: "relative", right: "-35%", top: "5%"}}>
            <h1 style={{fontSize: "4em"}}>Enter Pin</h1>
            <input
                style={{fontSize: "3em", position: "relative", right: "19%"}}
                type="text"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
            />
            <br/>
            <PlayButton onClick={() => { CheckPin() }}>
                Submit
            </PlayButton>
            </div>
        </Popup>
        );
    };

    var game = {
        id: 23,
        game_type: "assessnumeracy"
    }

    function DoAssignment() {
        console.log(assignments);
        console.log(doingAssignment);
        updateDoingAssignment(currentTask);
    }

    function EndAssignment() {
        updateDoingAssignment(null);

        axios({
            url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${access_token}`
            }
        }).then((response) => {
            if (response.data !== undefined) {
                var i;
                var count = 0;
                console.log(response.data);
                var temphomeworks = [];
                response.data.forEach(element => {
                    var temphomework = element;
                    console.log(element);
                    if (element.custom_list != undefined) {
                    var customlist = JSON.parse(temphomework.custom_list).list;
                    console.log("NOT UNDEFINED");
                    console.log(customlist);
                    temphomework.customlist = customlist;
                    }
                    temphomeworks.push(temphomework);
                });
                
                updateAssignments(temphomeworks);
                for (i = 0; i < response.data.length; i++) {
                    if (response.data[i].important == 1 && response.data[i].submissions.length == 0 && response.data[i].assessment_type != "clash") {
                        count++;
                    }
                }

                if (count > 0) {
                    props.update(true);
                    console.log("had important");
                    console.log(props.update);
                }
                else {
                    props.update(false);
                    console.log("no important");
                    console.log(props.update);
                }
            }
        });
    }

    useEffect(() => {
        const getPupilAssignments = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined) {
                    console.log(response.data);
                    var temphomeworks = [];
                    response.data.forEach(element => {
                        var temphomework = element;
                        console.log(element);
                        if (element.custom_list != undefined) {
                        var customlist = JSON.parse(temphomework.custom_list).list;
                        console.log("NOT UNDEFINED");
                        console.log(customlist);
                        temphomework.customlist = customlist;
                        }
                        temphomeworks.push(temphomework);
                    });
                    
                    updateAssignments(temphomeworks);
                    var i;
                    var count = 0;
                    var incompleteCounter = 0;
                    var clashCounter = 0;

                    for (i = 0; i < response.data.length; i++) {
                        if (new Date(Date.parse(response.data[i].starts_at)) < new Date() && response.data[i].assessment_type != "clash" && response.data[i].important == 1 && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                            count++;
                        }

                        if (response.data[i].assessment_type != "clash" && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                            incompleteCounter++;
                        }

                        if (response.data[i].assessment_type == "clash" && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                            clashCounter++;
                        }
                    }

                    if (count > 0) {
                        props.update(true, incompleteCounter);
                        console.log("had important");
                        console.log(props.update);
                    }
                    else {
                        props.update(false, incompleteCounter);
                        console.log("no important");
                        console.log(incompleteCounter);
                        console.log(props.update);
                        if (clashCounter > 0){
                            props.clashupdate(true, clashCounter);
                        }
                    }
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getPupilAssignments();
    }, []);

    function handleSubmit(event) {
        console.log(event);
        event.preventDefault();
        CheckCode();
    }

    function CheckCode(){
        console.log(props);
        console.log(state);
        var params = {
            id: state.pupil.pupil_id,
            code: answer
        };
        try {
            (async () => {
                const response = await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/getworksheettask`,
                    params,
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${state.access_token}`
                      },
                });
                
                console.log(response.data);
                if (response.data == ""){
                    alert('No Task Found')
                }else{
                    if (response.data.assessment_type != "learn" && response.data.assessment_type != "" && response.data.assessment_type != null){
                        alert('You can only play this task code in the app');
                    }else{
                        var assignment = null;
                        assignments.forEach(item => {
                            if (item.id == response.data.id){
                                assignment = item;
                            }
                        });
                        updateDoingAssignment(response.data);
                    }
                }
            })();
        } catch (e) {
            console.log(e);
        }
    }

    function handleChange(event) {
        console.log(event);
        setAnswer(event.target.value.toUpperCase());
        setDisplayValue(event.target.value.toUpperCase())
    }

    // Advanced Filtering Logic implementation
    const filteredAssignments = assignments ? assignments.filter(assignment => {
        // Carry over basic structural restrictions
        if (assignment.assessment_type == "clash" || (assignment.code != "" && assignment.code != null)) {
            return false;
        }

        // Apply Month filter evaluation based on Due Date (ends_at)
        if (selectedMonth !== "All") {
            const taskMonthIndex = new Date(assignment.ends_at).getMonth();
            if (monthsList[taskMonthIndex] !== selectedMonth) {
                return false;
            }
        }

        // Apply Subject filter evaluation
        if (selectedSubject !== "All") {
            const correspondingSubject = game_data.find(gd => gd.id == assignment.galaxy_id);
            if (!correspondingSubject || correspondingSubject.description !== selectedSubject) {
                return false;
            }
        }

        return true;
    }) : [];

    return doingAssignment ? (
        <div>
            {doingAssignment.galaxy_id == 22 && doingAssignment.galaxy_id != 23 ? (
                <MTC
                    game={game}
                    access={doingAssignment.assessment_type}
                    homework_id={doingAssignment.id}
                    topics={doingAssignment.topics.map(t => t.topic_key)}
                    homework={doingAssignment}
                    timer ={doingAssignment.timelimit}
                    options ={doingAssignment.options}
                />
            ) : <div/>}
            {doingAssignment.galaxy_id == 35 ? (
                <Assessment game={game} homework={doingAssignment} />
            ) : <div/>}
            {doingAssignment.galaxy_id == 23 && doingAssignment.galaxy_id != 22 ? (
                <NumInt game={game} homework_id={doingAssignment.id} />
            ) : <div/>}

            {(doingAssignment.assessment_type != "learn" && doingAssignment.assessment_type != "learn|upper" && doingAssignment.assessment_type != "learn|lower")  && doingAssignment.galaxy_id != 23 && doingAssignment.galaxy_id != 22 && doingAssignment.galaxy_id != 35 ? (
                <Practice
                    id={doingAssignment.galaxy_id}
                    topicKeys = {doingAssignment.topics.map(t => t.topic_key)}
                    topics={doingAssignment.topics.map(t => t.id)}
                    startImmediately={true}
                    onEnd={() => EndAssignment()}
                    homework_id={doingAssignment.id}
                    dabs={true}
                    customlist = {doingAssignment.customlist}
                    timelimit = {doingAssignment.timelimit}
                    minimum = {doingAssignment.minimum}
                    assessment_type ={doingAssignment.assessment_type}
                />
            ) : <div/>}

            {doingAssignment.assessment_type == "learn" || doingAssignment.assessment_type == "learn|upper" || doingAssignment.assessment_type == "learn|lower"  ? (
                <Learn
                    type={doingAssignment.assessment_type}
                    id={doingAssignment.galaxy_id}
                    topicKeys = {doingAssignment.topics.map(t => t.topic_key)}
                    topics={doingAssignment.topics.map(t => t.id)}
                    startImmediately={true}
                    onEnd={() => EndAssignment()}
                    homework_id={doingAssignment.id}
                    dabs={true}
                    customlist = {doingAssignment.customlist}
                    timelimit = {doingAssignment.timelimit}
                    minimum = {doingAssignment.minimum}
                />
            ) : <div/>}
        </div>
    ) : (
            <AssignmentsContainer>
                <FilterControlBar>
                    <ControlBox>
                        <Label>Enter Task Code</Label>
                        <Frame>
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <input type="text" value={displayValue} onChange={(e) => handleChange(e)}/>
                                <CodeButton type="submit" value="Submit">Submit</CodeButton>
                            </form>
                        </Frame>
                    </ControlBox>

                    <ControlBox>
                        <Label>Month</Label>
                        <SelectDropdown value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                            <option value="All">All</option>
                            {monthsList.map((m, idx) => (
                                <option key={idx} value={m}>{m}</option>
                            ))}
                        </SelectDropdown>
                    </ControlBox>

                    <ControlBox>
                        <Label>Subject</Label>
                        <SelectDropdown value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)}>
                            <option value="All">All</option>
                            {subjectsList.map((s, idx) => (
                                <option key={idx} value={s}>{s}</option>
                            ))}
                        </SelectDropdown>
                    </ControlBox>
                </FilterControlBar>

                <PinPopup></PinPopup>
                
                <Scale scaleTo={1720} style={{width: "60%"}}>
                    {assignments !== null ? (
                        filteredAssignments.length !== 0 ? (
                            filteredAssignments.map((assignment, index) => {
                                let margin =
                                    (((filteredAssignments.length < 4) && (index === 0)) ? "top" :
                                        (((filteredAssignments.length < 4) && (index === filteredAssignments.length - 1)) ? "bottom" :
                                            null));

                                return (
                                    <Assignment 
                                        key={assignment.id} 
                                        assignment={assignment} 
                                        margin={margin} 
                                        playAssignment={updateDoingAssignment} 
                                        enterPin={() => EnterPin(assignment)}
                                    />
                                );
                            })
                        ) : (
                                <h1 style={{textAlign: "center", marginTop: "40px"}}>No matching tasks found...</h1>
                            )
                    ) : (
                            <h1>Fetching your tasks...</h1>
                        )}
                </Scale>
            </AssignmentsContainer>
        );
}

export default Assignments;

const FilterControlBar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 30px;
    margin-bottom: 25px;
    width: 60%;
    
    @media (max-width: 1024px) {
        width: 90%;
        gap: 15px;
    }
`;

const ControlBox = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #fdfbfe;
    border: 3px solid #dbd2ea;
    border-radius: 12px;
    padding: 10px 15px 15px 15px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
`;

const Label = styled.div`
    font-size: 1.4em;
    font-weight: bold;
    color: #673b8b;
    margin-bottom: 8px;
    text-align: center;
`;

const SelectDropdown = styled.select`
    width: 100%;
    height: 52px;
    font-size: 1.8em;
    font-weight: bold;
    color: white;
    text-align: center;
    text-align-last: center;
    background: linear-gradient(0deg, rgba(234, 146, 19, 1) 0%, rgba(255, 186, 32, 1) 100%);
    border: 2px solid #e88f12;
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    box-shadow: 0px 4px 0px #c27607;
    transition: transform 0.1s ease;

    option {
        background-color: white;
        color: #333;
        font-weight: normal;
        font-size: 0.8em;
    }

    &:active {
        transform: translateY(2px);
        box-shadow: 0px 2px 0px #c27607;
    }
`;

const CodeButton = styled.button`
    font-size: 1.8em;
    font-weight: bold;
    background: rgb(234, 146, 19);
    background: linear-gradient(
        0deg,
        rgba(234, 146, 19, 1) 0%,
        rgba(255, 186, 32, 1) 100
    );
    border: 2px solid #e88f12;
    color: #fff;
    user-select: none;
    padding: 0 1.5em;
    height: 52px;
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 4px 0px #c27607;

    &:active {
        transform: translateY(2px);
        box-shadow: 0px 2px 0px #c27607;
    }
`;

const Frame = styled.div`
  form {
    display: flex;
    width: 100%;
  }

  input {
    flex: 1;
    height: 48px;
    margin-right: 12px;
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 8px;
    padding: 0 10px;
    font-size: 1.8em;
    color: #673b8b;
    font-weight: bold;
    text-align: center;
    box-sizing: border-box;
  }
`;